import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function AdminHeader() {
  const navigate = useNavigate();

  // Safely get user email from localStorage with fallback
  const getUserEmail = () => {
    try {
      return localStorage.getItem("userEmail") || "admin@example.com";
    } catch (error) {
      console.warn("Failed to access localStorage:", error);
      return "admin@example.com";
    }
  };

  const userEmail = getUserEmail();
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const handleLogout = () => {
    try {
      localStorage.removeItem("userType");
      localStorage.removeItem("userEmail");
    } catch (error) {
      console.warn("Failed to clear localStorage:", error);
    }
    navigate("/login");
  };

  const handleNavigateHome = () => {
    try {
      navigate("/");
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center min-w-0">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 flex items-center justify-center">
                <img
                  src="/favicon.png"
                  alt="Olympic Academy Logo"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <div>
                <h1
                  className="text-xl font-bold text-gray-900"
                  style={{
                    fontFamily: '"Inter", "Roboto", sans-serif',
                    fontWeight: "700",
                  }}
                >
                  Olympic Academy
                </h1>
              </div>
            </div>
            <span className="hidden sm:inline ml-4 text-xs sm:text-sm text-gray-500 border-l border-gray-300 pl-4 whitespace-nowrap">
              Quản trị viên
            </span>
          </div>

          <div className="flex items-center space-x-2 sm:space-x-4">
            <div className="hidden md:flex items-center text-sm text-gray-700">
              <div className="w-8 h-8 bg-gradient-to-r from-yellow-100 to-red-100 rounded-full flex items-center justify-center mr-2 sm:mr-3">
                <i className="ri-admin-line text-red-500"></i>
              </div>
              <span className="hidden lg:inline truncate max-w-[150px]">
                {userEmail}
              </span>
            </div>

            <button
              onClick={handleLogout}
              className="hidden sm:flex items-center px-3 sm:px-4 py-2 text-sm text-gray-700 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all whitespace-nowrap"
            >
              <i className="ri-logout-box-line mr-1 sm:mr-2"></i>
              <span className="hidden lg:inline">Đăng xuất</span>
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setShowMobileMenu(!showMobileMenu)}
              className="sm:hidden p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg"
            >
              <i
                className={`${
                  showMobileMenu ? "ri-close-line" : "ri-menu-line"
                } text-xl`}
              ></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {showMobileMenu && (
        <div className="sm:hidden border-t border-gray-200 bg-white">
          <div className="px-4 py-3 space-y-2">
            <div className="flex items-center space-x-3 pb-3 border-b border-gray-200">
              <div className="w-10 h-10 bg-gradient-to-r from-yellow-100 to-red-100 rounded-full flex items-center justify-center">
                <i className="ri-admin-line text-red-500"></i>
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-gray-900 truncate">
                  {userEmail}
                </p>
                <p className="text-xs text-gray-500">Quản trị viên</p>
              </div>
            </div>
            <button
              onClick={handleLogout}
              className="w-full flex items-center px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            >
              <i className="ri-logout-box-line mr-2"></i>
              Đăng xuất
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
